<template>
  <v-container fluid>
    <v-layout row wrap justify-center>
      <v-flex xs12 lg10>
        <v-layout 
      row 
      wrap>
      <h1>Unknown Utterances</h1>
      <v-spacer />
      <v-btn to="/nlp" style="float: right" color="primary">
        NLP Apps
      </v-btn>
    </v-layout>
    <v-flex xs12>
     <unknown-words style = "padding-top: 0"/>
    </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import unknownWords from '@/components/insights/unknown-words'
export default {

  name: 'index',
  components: {
	unknownWords
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>